export default "__VITE_ASSET__BD0NRLSE__"